var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStomachRebrand = function SvgStomachRebrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Stomach-rebrand_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "M12.003 19.219H7.2v-1.203a1.202 1.202 0 1 0-2.405 0v1.203H0v-1.203a6 6 0 0 1 5.997-5.997 6 6 0 0 1 5.998 5.997v1.203h.016z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "M18.593 9.621H16.79a7.2 7.2 0 0 1-7.2-7.2V.031h4.802v2.39A2.396 2.396 0 0 0 16.79 4.82h1.803z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "M9.597.016h2.398v2.397a4.805 4.805 0 0 0 4.802 4.803h1.804v2.397h-1.804a7.206 7.206 0 0 1-7.2-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "M26.403.016A9.59 9.59 0 0 1 36 9.613v4.803c0 9.273-7.517 16.797-16.797 16.797-6.63 0-12.003-5.372-12.003-12.01h4.803a4.805 4.805 0 0 0 4.802-4.803V9.597A9.597 9.597 0 0 1 26.403 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "M31.19 4.819a4.805 4.805 0 0 0-4.803 4.802v7.2a7.2 7.2 0 0 1-7.2 7.2h-4.803a4.805 4.805 0 0 1-4.802-4.802v-1.203c0-1.994-1.607-3.6-3.6-3.6a3.593 3.593 0 0 0-3.6 3.6v1.203h2.397v-1.203a1.202 1.202 0 1 1 2.405 0v1.203c0 6.63 5.373 12.002 12.003 12.002 9.28 0 16.797-7.516 16.797-16.79v-4.81a4.805 4.805 0 0 0-4.802-4.802h.015z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F1F",
    d: "M12.003 20.92h-2.09c1.069 4.138 4.835 7.2 9.29 7.2h.07c5.302 0 9.954-2.912 12.423-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1F8FA",
    d: "M19.203 15.025a.59.59 0 0 1-.594-.593v-4.81c0-4.305 3.505-7.794 7.794-7.794.332 0 .593.261.593.593a.594.594 0 0 1-.593.602c-3.64 0-6.607 2.959-6.607 6.598v4.81a.59.59 0 0 1-.593.594"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D24E23",
    d: "M16.505 26.316a1.494 1.494 0 1 0 .002-2.989 1.494 1.494 0 0 0-.003 2.989M19.804 23.317a.594.594 0 0 0 .593-.601.593.593 0 1 0-1.186 0c0 .324.269.601.593.601M24.702 25.722a.706.706 0 0 0 .704-.704.706.706 0 0 0-.704-.704.706.706 0 0 0-.705.704c0 .388.317.704.704.704"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Stomach-rebrand_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v31.221H0z"
  })))));
};
export default SvgStomachRebrand;